import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 * @param cancelToken - Token to cancel multiple requests
 * @returns - Array of Terminal List of type IManifest
 */

export const manifestDetailsApi = async (manifestNumber: string, partialHeaders?: any) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      "OSD-Module-Name": "myAssignments",
      "OSD-Section-Name": "manifestDetails",
      "OSD-Action-Type": "get",
      ...partialHeaders,
    };
    const response = await axios.get(`${getUrl(ApiType.MANIFEST_DETAILS)}/${manifestNumber}`, { headers });
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.manifestDetails, { badRequestOrder: "errorsFirst" });
  }
};
